import React from 'react';
import Anime, { anime } from 'react-anime';
import bubble5 from '../assets/elements/bubble/bubble-image-13.png';
import vialImg from '../assets/photos/vials.png';
import './Vials.scss';
export default ({ isActive }) => {
  const slideVials = {
    translateY: [
      { value: -1000, duration: 0},
      { value: 0, duration: 2220}
    ],
    delay: anime.stagger(250, { start: 500 })
  }

  const scaleImg = {
    scale: [
      { value: 0, duration: 0 },
      { value: 1, duration: 1000, easing: 'linear'}
    ]
  }
  return (
    <div className="vials-container">
      <div className="vial-text">
        {isActive && (
          <Anime {...scaleImg} className="landscape-hide vials-image-circle"><img src={bubble5} alt="healing" /> </Anime>
        )}
        <p className="secondary-large">In a 2017 survey of over 2,000 clinical trial participants worldwide, 94% said that they would do so again and 91% would recommend participation to others.</p>
      </div>
      <div className="vial">
        {isActive && (
          <Anime {...slideVials} className="vial-inner">
            <div className="vials-inner-container">
              <img src={vialImg} />
              <div className="numbers-container">
                <span className="numbers">94<sup>%</sup></span>
              </div>
            </div>
            <div className="vials-inner-container">
              <img src={vialImg} />
              <div className="numbers-container">
                <span className="numbers">91<sup>%</sup></span>
              </div>
            </div>
          </Anime>
        )}
      </div>
    </div>
  );
};